import * as React from "react";
export const GoogleLogoIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={364.45} height={371.86} viewBox="0 0 364.45 371.86" {...props}>
      <g transform="translate(-0.751 -0.019)">
        <path
          d="M125.9,10.2a188.357,188.357,0,0,1,125.3,1.1,180.755,180.755,0,0,1,59.9,37.1C305.3,54.7,299,60.6,293,66.7l-34.2,34.2a101.306,101.306,0,0,0-40.1-23.6,109.813,109.813,0,0,0-54.6-2.2A111.148,111.148,0,0,0,108.5,106a115.412,115.412,0,0,0-27,43.9c-20.3-15.8-40.6-31.5-61-47.3C42,59.6,80.6,25.7,125.9,10.2Z"
          fill="#ea4335"
        />
        <path
          d="M20.6,102.4c20.3,15.8,40.6,31.5,61,47.3a112.2,112.2,0,0,0,0,72.4q-30.45,23.7-60.9,47.3a185.091,185.091,0,0,1-.1-167Z"
          fill="#fbbc05"
        />
        <path
          d="M361.7,151.1c5.8,32.7,4.5,66.8-4.7,98.8-8.5,29.3-24.6,56.5-47.1,77.2l-59.1-45.9A87.608,87.608,0,0,0,288,223.7H186.6q.15-36.3.1-72.6Z"
          fill="#4285f4"
        />
        <path
          d="M81.4,222.2A115.594,115.594,0,0,0,124,279.3a110.81,110.81,0,0,0,41.4,17.9c14.6,3,29.7,2.6,44.4.1a106.55,106.55,0,0,0,41-16.2L309.9,327c-21.3,19.7-48,33.1-76.2,39.6-31.2,7.1-64.2,7.3-95.2-1a183.793,183.793,0,0,1-67.6-34.1,187.264,187.264,0,0,1-50.4-62q30.45-23.55,60.9-47.3Z"
          fill="#34a853"
        />
      </g>
    </svg>
  );
};
